// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { updateQuoteLine as updateQuoteLineApi, updateQuoteLinesList } from "@bg/App/Services/QuoteService";
import { HandlerWithResult, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    RequestUpdateQuoteLine,
} from "@insite/client-framework/Store/Pages/RfqQuoteDetails/Handlers/UpdateQuoteLine";
import { QuoteLineModel } from "@insite/client-framework/Types/ApiModels";

interface UpdateQuoteLineResult {
    quoteLine?: QuoteLineModel;
    errorMessage?: string;
}

type HandlerType = HandlerWithResult<
    {
        quoteId: string;
        quoteLineId: string;
        quoteLine: QuoteLineModel;
        originalGroupName?: string;
        updatePriceBreakInfo?: boolean;
        minimumQty?: string;
        isFixedQty?: boolean;
        asList?: boolean;
        quoteLines: QuoteLineModel[];
    } & HasOnSuccess,
    UpdateQuoteLineResult
>;

export const XngRequestUpdateQuoteLine: HandlerType = async props => {
    props.dispatch({
        type: "Data/Quotes/BeginLoadQuote",
        quoteId: props.parameter.quoteId,
    });

    if (props.parameter.asList) {
        await updateQuoteLinesList({
            quoteId: props.parameter.quoteId,
            quoteLines: props.parameter.quoteLines,
        });
        return;
    }

    const apiParameter = {
        quoteId: props.parameter.quoteId,
        quoteLineId: props.parameter.quoteLineId,
        quoteLine: props.parameter.quoteLine,
    } as any;
    apiParameter.updatePriceBreakInfo = props.parameter.updatePriceBreakInfo;
    if (props.parameter.updatePriceBreakInfo) {
        apiParameter.isFixedQty = props.parameter.isFixedQty;
        if (props.parameter.isFixedQty) {
            apiParameter.exactQty = props.parameter.minimumQty;
        } else {
            apiParameter.exactQty = "";
        }

        if (props.parameter.minimumQty && !props.parameter.isFixedQty) {
            apiParameter.minimumQty = props.parameter.minimumQty;
        } else {
            apiParameter.minimumQty = "";
        }
    }

    if (props.parameter.originalGroupName) {
        apiParameter.originalGroupName = props.parameter.originalGroupName;
    }
    await updateQuoteLineApi(apiParameter as any);
};

replaceInChain(chain, RequestUpdateQuoteLine, XngRequestUpdateQuoteLine);
